import { Action } from 'redux'
import SettingsActions, { SetSettingsAction } from './actions'
import SettingsState, { getDefaultSettingsState } from './SettingsState'

export const reducer = (state: SettingsState = getDefaultSettingsState(), action: Action) => {
    switch(action.type) {
        case SettingsActions: {
            const setSettingsAction = action as SetSettingsAction
            return {
                ...setSettingsAction.settings
            }
        }
        default:
            return state
    }
}
